const URL_PARAMETERS = ['gclid__c', 'gclid', 'slcode', 'irclickid'];

export default URL_PARAMETERS;
